import {useState} from 'react';

import {useAuth} from '~/store/hooks';
import {AuditLogModal} from './AuditLogModal';

export const AuditLogButton = ({endpoints}: {endpoints: string[]}) => {
  const {adminUser} = useAuth();
  const [showModal, setShowModal] = useState(false);

  if (!adminUser?.superAdmin) {
    return null;
  }

  return (
    <>
      <button
        type="button"
        className="btn btn-link btn-sm mt-6 px-0"
        onClick={() => setShowModal(true)}>
        Logs
      </button>
      {showModal && (
        <AuditLogModal
          endpoints={endpoints}
          onCancel={() => setShowModal(false)}
        />
      )}
    </>
  );
};
